<template>
  <section>
    <error-alert v-if="$store.getters.errorMessageWithFilterRate" />
    <template v-else>
      <b-table
        class="filter-rate-table text-center"
        id="table-transition-filter"
        head-variant="dark"
        responsive
        small
        striped
        hover
        sort-icon-left
        :fields="fields"
        :items="items"
        :tbody-tr-class="rowClass"
        :primary-key="items.stock_symbol"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template v-slot:head()="{ label }">
          {{ whatIsLabelUnit(label) }}
        </template>
        <template v-slot:cell(stock_symbol)="{ item }">
          <a
            class="text-info"
            target="_blank"
            rel="noreferrer noopener"
            :href="
              `https://stock.chuen.com.tw/stock/${item.stock_symbol}/chart-profit-year`
            "
            >{{ item.stock_symbol }}
          </a>
        </template>
        <template v-slot:cell(level)="{ item }">
          <b-form-select
            :disabled="!$store.getters.loggedInInfo.is_admin"
            id="inline-form-custom-select-pref"
            size="sm"
            :key="item.stock_symbol"
            :options="['-', 'A', 'B', 'C', 'D']"
            :value="item.level"
            @change="
              $store.dispatch('FETCH_UPDATE_LEVEL_WITH_RATE', {
                select: $event,
                stockSymbol: item.stock_symbol
              })
            "
          ></b-form-select>
        </template>
        <template v-slot:cell(go_public)="{ item }">
          <b-form-select
            :disabled="!$store.getters.loggedInInfo.is_admin"
            id="inline-form-custom-select-companyType"
            size="sm"
            :key="item.stock_symbol"
            :options="[
              { text: '上市', value: '1' },
              { text: '下市', value: '0' }
            ]"
            :value="item.go_public"
            @change="
              $store.dispatch('FETCH_UPDATE_TYPE_WITH_RATE', {
                select: $event,
                stockSymbol: item.stock_symbol
              })
            "
          ></b-form-select>
        </template>
      </b-table>
    </template>
  </section>
</template>

<script>
// import { termInChinese } from "@/utility/termInChinese.js";
import ErrorAlert from "@/components/ErrorAlert.vue";

export default {
  name: "FilterRateTable",
  components: {
    ErrorAlert
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      sortBy: "stock_symbol",
      sortDesc: false
    };
  },
  methods: {
    rowClass(item) {
      return (
        item.consider_fund_reinvestment > item.closing_price && "table-info"
      );
    },
    tdClass(value) {
      return Math.sign(value) === -1 && "text-danger";
    },
    whatIsLabelUnit(label) {
      switch (label) {
        case "股本":
        case "市值":
          return `${label}(百萬元)`;
        case "昨收":
        case "每股淨值":
        case "預估每股合理價值":
        case "預估每股合理價值-考慮資金再投資":
        case "近四季每股EPS":
        case "本益比":
        case "每股EBIDTA":
        case "近四季每股EBIDTA":
          return `${label}(元)`;
        case "折價比":
        case "EBPR":
        case "毛利率":
        case "EBOIC":
        case "ROIC":
          return `${label}(%)`;
        default:
          return label;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .thead-dark {
  font-size: 0.88rem;
}
::v-deep .table-hover tbody tr:hover {
  background-color: #343a40;
  color: #fff;
}
::v-deep .table-hover tbody tr.table-info {
  color: #343a40;
}
::v-deep tbody td {
  vertical-align: middle;
}
</style>
